<template>
  <div v-if="length > 1" class="e-pagination">
    <e-btn
      v-if="page > 1"
      variant="ghost"
      prepend-icon-src="arrowLeft"
      size="M"
      :icon="$vuetify.display.smAndDown"
      :prepend-icon-size="20"
      @click="onBack"
    >
      <span v-if="$vuetify.display.mdAndUp">Назад</span>
    </e-btn>

    <e-btn
      v-for="item in items"
      :key="item"
      :variant="page === item ? 'primary' : 'ghost'"
      size="M"
      @click="onItemClick(item)"
    >
      {{ item }}
    </e-btn>

    <e-btn
      v-if="page < length"
      variant="ghost"
      append-icon-src="arrowRight"
      :icon="$vuetify.display.smAndDown"
      :append-icon-size="20"
      size="M"
      @click="onForward"
    >
      <span v-if="$vuetify.display.mdAndUp">Далее</span>
    </e-btn>
  </div>
</template>

<script lang="ts" setup>
import { toRef } from 'vue';
import { useDisplay } from 'vuetify';
import { EBtn } from '../ui';

const props = defineProps<{
  count: number;
  pageSize: number;
}>();

const page = defineModel<number>({ required: true });

const $display = useDisplay();

const maxVisibleCount = toRef(() => ($display.mdAndUp.value ? 10 : 5));

const length = toRef(() => Math.ceil(Math.abs(props.count / props.pageSize)));

const items = toRef(() => {
  const arr = [];

  for (
    let i =
      page.value > length.value - Math.floor(maxVisibleCount.value / 2)
        ? Math.max(length.value - maxVisibleCount.value + 1, 1)
        : Math.max(page.value - Math.floor(maxVisibleCount.value / 2), 1);
    i < Math.min(Math.max(page.value + Math.floor(maxVisibleCount.value / 2), maxVisibleCount.value), length.value) + 1;
    i++
  ) {
    arr.push(i);
  }

  return arr;
});

const onBack = () => {
  page.value--;
};

const onForward = () => {
  page.value++;
};

const onItemClick = (item: number) => {
  page.value = item;
};
</script>

<style lang="scss" scoped>
.e-pagination {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
